<template>
  <div>
    <v-banner single-line sticky>
      <v-row>
        <v-col>
          <h3 class="pb-2">
            OPEN SUB CASE | CASEID :
            {{ showdata.caseid }} | PROJECT : {{ showdata.project }}
          </h3>
        </v-col>
      </v-row>
    </v-banner>
    <br />
    <v-card>
      <v-form ref="form" v-model="information.valid">
        <v-oldinformation :condition="condition" :information="old_detail" />
        <engineer-information
          :condition="condition"
          :information="information"
          v-if="information.site_name !== ''"
        />
        <part-information
          :condition="condition"
          :information="information"
          v-if="information.site_name !== ''"
        />
      </v-form>
      <v-row justify="center">
        <v-col cols="8" v-if="isSaving">
          <v-progress-linear class="ma-10" indeterminate color="cyan"></v-progress-linear>
        </v-col>
        <v-btn
          v-if="!isSaving"
          :disabled="!information.valid"
          @click="saveCase()"
          class="ma-4"
          tile
          color="success"
        >
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
<!-- <v-btn class="ma-4" tile color="warning">
          <v-icon left>mdi-close-octagon</v-icon>Cancel
        </v-btn>-->
      </v-row>
    </v-card>

    <!-- Save Result Modal -->
    <v-dialog v-model="saveResultDialog" max-width="860px" persistent>
      <v-card class="save-result-card">
        <div class="save-result-header">
          <div class="save-result-icon-wrap">
            <v-icon size="48" color="white">mdi-check-circle</v-icon>
          </div>
          <div class="save-result-header-text">
            <div class="save-result-title">บันทึก Sub Case สำเร็จ</div>
            <div class="save-result-subtitle">Subcase has been created successfully</div>
          </div>
        </div>

        <div class="save-result-info">
          <div class="save-result-info-box">
            <div class="save-result-info-label">Case ID</div>
            <div class="save-result-info-value">{{ saveResult.case_id }}</div>
          </div>
          <v-divider vertical class="mx-4"></v-divider>
          <div class="save-result-info-box">
            <div class="save-result-info-label">Subcase</div>
            <div class="save-result-info-value"># {{ saveResult.subcase }}</div>
          </div>
          <v-divider vertical class="mx-4"></v-divider>
          <div class="save-result-info-box">
            <div class="save-result-info-label">Parts</div>
            <div class="save-result-info-value">{{ saveResult.parts ? saveResult.parts.length : 0 }} รายการ</div>
          </div>
        </div>

        <v-card-text class="px-6 pb-2">
          <div v-if="saveResult.parts && saveResult.parts.length">
            <div class="save-result-parts-title">
              <v-icon small class="mr-1" color="blue darken-2">mdi-package-variant</v-icon>
              Parts Recommend
            </div>
            <v-simple-table class="save-result-table">
              <thead>
                <tr>
                  <th style="width:150px">Part Number</th>
                  <th>Description</th>
                  <th style="width:160px">LPN</th>
                  <th style="width:160px">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in saveResult.parts" :key="i"
                  :class="p.status !== 'Recommended' ? 'save-result-row-warn' : ''">
                  <td class="font-weight-medium">{{ p.part_number }}</td>
                  <td class="grey--text text--darken-2">{{ p.part_desc }}</td>
                  <td>
                    <span v-if="p.lpn" class="save-result-lpn">{{ p.lpn }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td>
                    <div class="d-flex align-center">
                      <v-icon small class="mr-1"
                        :color="p.status === 'Recommended' ? 'green darken-1' : 'red darken-1'">
                        {{ p.status === 'Recommended' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                      </v-icon>
                      <span :class="p.status === 'Recommended' ? 'green--text text--darken-1' : 'red--text text--darken-1'"
                        class="font-weight-medium caption">
                        {{ p.status }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else class="save-result-noparts">
            <v-icon color="grey lighten-1" size="32">mdi-package-variant-closed</v-icon>
            <span class="ml-2 grey--text">ไม่มีรายการอะไหล่</span>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pt-3 pb-5">
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" @click="afterSaveConfirm()">
            <v-icon left small>mdi-eye</v-icon>ไปดูเคส
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

import CaseInformation from "../components/CaseInformation";
import ProductInformation from "../components/ProductInformation";
import CustomerInformation from "../components/CustomerInformation";
import EngineerInformation from "../components/EngineerInformation";
import PartInformation from "../components/PartInformationNew.vue";
import LogInformation from "../components/LogInformation";
import EngineerNewInformation from "../components/EngineerNewInformation";
import OldSub from "../components/OldSub";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    "case-information": CaseInformation,
    "customer-information": CustomerInformation,
    "product-information": ProductInformation,
    "engineer-information": EngineerNewInformation,
    "part-information": PartInformation,
    "log-information": LogInformation,
    "v-oldinformation": OldSub,
  },
  computed: {
    ...mapState(["isLoading"]),
  },
  mounted() {
    this.getDetail();
  },
  data() {
    return {
      isSaving: false,
      closeOnClick: false,
      saveResultDialog: false,
      saveResult: { case_id: null, subcase: null, parts: [] },
      showdata: {
        caseid: "",
        project: "",
      },
      condition: {
        status: "subcase",
        team: localStorage.team_name,
      },
      information: {
        site_name: "",
        site_address: "",
        site_postcode: "",
        site_district_id: "",
        site_amphur_id: "",
        site_province_id: "",
        branch_id: "",
        engineer: "",
        part: [],
      },
      options: {
        offset: 100,
      },
      lists: [
        {
          eleId: "#case",
          eleName: "Case Information",
        },
        {
          eleId: "#product",
          eleName: "Products Information",
        },
        {
          eleId: "#customer",
          eleName: "Customer Information",
        },
        {
          eleId: "#lognote",
          eleName: "Log Note",
        },
        {
          eleId: "#attach",
          eleName: "Attachments",
        },
        {
          eleId: "#parts",
          eleName: "Parts Information",
        },
        {
          eleId: "#services",
          eleName: "Services Information",
        },
        {
          eleId: "#happycall",
          eleName: "Happy Call",
        },
        {
          eleId: "#performance",
          eleName: "Performance",
        },
      ],
      old_detail: [],
    };
  },
  methods: {
    ...mapMutations(["mutateIsLoading"]),
    async saveCase() {
      if (this.isSaving) return
      this.isSaving = true
      ;(this.information.part || []).map((each) => {
        if (each.part_no == "") {
          this.information.part = [];
        }
      });
      this.information.case_sla_datetime =
        this.information.case_sla_date + " " + this.information.case_sla_time;
      const url = `${process.env.VUE_APP_ROOT_API}/api/new-subcase/${this.$route.params.caseid}`;
      const options = {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      };
      try {
        this.mutateIsLoading();
        let { data, status } = await axios.post(url, this.information, options);
        this.mutateIsLoading();
        if ((status === 200 || status === 201) && data && data.case_id) {
          this.saveResult = {
            case_id: data.case_id,
            subcase: data.subcase,
            parts: data.parts || [],
          }
          this.saveResultDialog = true
        }
      } catch (error) {
        console.log(error.message);
      }
      this.isSaving = false
    },
    async getDetail() {
      const url = `${process.env.VUE_APP_ROOT_API}/api/open-new-sub/${this.$route.params.caseid}`;
      try {
        const { data } = await axios.get(`${url}`);
        this.old_detail = data.sub;
        this.information = {
          problem_type: [
            { problem_type_name: "Hardware", problem_type_id: "5" },
            { problem_type_name: "Software", problem_type_id: "4" },
          ],
          ...data.main,
          part: data.main.part || [],
        };

        this.showdata.caseid = this.information.case_id;
        this.showdata.project = this.information.project_name;
        this.condition.project = this.information.project_name;
      } catch (error) {
        console.log(error);
      }
    },
    // getDetailSub() {
    //   this.information.subs.map((each, i, arr) => {
    //     if (arr.length - 1 === i) {
    //       this.information = {
    //         project_id: this.information.project_id,
    //         problem_group_id: this.information.problem_group_id,
    //         ...each,
    //       };
    //     }
    //   });
    // },
afterSaveConfirm() {
      this.saveResultDialog = false
      this.$router.push("/Project/ViewCasepending/Nonhp/" + this.$route.params.caseid)
    },
    gotoLink(eleId) {
      this.$vuetify.goTo(eleId, this.options);
    },
  },
};
</script>

<style>
.save-result-card { border-radius: 12px !important; overflow: hidden; }
.save-result-header { background: linear-gradient(135deg, #2e7d32, #43a047); display: flex; align-items: center; padding: 20px 28px; gap: 16px; }
.save-result-icon-wrap { background: rgba(255,255,255,0.15); border-radius: 50%; width: 64px; height: 64px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.save-result-header-text { color: white; }
.save-result-title { font-size: 20px; font-weight: 700; line-height: 1.2; }
.save-result-subtitle { font-size: 13px; opacity: 0.8; margin-top: 2px; }
.save-result-info { display: flex; align-items: center; background: #f5f5f5; padding: 16px 28px; border-bottom: 1px solid #e0e0e0; }
.save-result-info-box { text-align: center; flex: 1; }
.save-result-info-label { font-size: 11px; color: #9e9e9e; text-transform: uppercase; letter-spacing: 0.8px; font-weight: 600; }
.save-result-info-value { font-size: 22px; font-weight: 700; color: #212121; margin-top: 2px; }
.save-result-parts-title { font-size: 13px; font-weight: 600; color: #1565c0; margin-bottom: 10px; margin-top: 16px; }
.save-result-table { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; }
.save-result-table thead tr { background: #f5f5f5; }
.save-result-table thead th { font-size: 12px !important; font-weight: 600 !important; color: #616161 !important; text-transform: uppercase; letter-spacing: 0.5px; }
.save-result-row-warn { background: #ffcdd2 !important; }
.save-result-row-warn td { border-bottom: 1px solid #ef9a9a !important; }
.save-result-lpn { font-family: monospace; font-size: 12px; background: #e3f2fd; color: #1565c0; padding: 2px 6px; border-radius: 4px; }
.save-result-noparts { display: flex; align-items: center; justify-content: center; padding: 24px 0; }
</style>
